import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";

const testimonials = [
  {
    name: "Emily Johnson",
    location: "Toronto, Canada",
    review:
      "AutoFinance Canada made my car financing experience unbelievably smooth! Even with my average credit score, they approved my application quickly and offered a great rate. Their support team was patient, honest, and professional throughout.",
    rating: 5,
    image: "/images/emili.jpg",

  },
  {
    name: "Liam Anderson",
    location: "Vancouver, Canada",
    review:
      "I’ve dealt with many lenders before, but none were as transparent as AutoFinance Canada. They didn’t just finance my SUV — they helped me understand every detail. The approval process was lightning fast!",
    rating: 5,
    image: "/images/liam.jpg",

  },
  {
    name: "Sophia Brown",
    location: "Calgary, Canada",
    review:
      "What impressed me most was their flexibility. I had a few financial setbacks, but AutoFinance Canada still found a plan that worked for me. Now I’m driving my dream car thanks to their incredible service!",
    rating: 5,
    image: "/images/sophi.jpg",

  },
];

function Testimonials() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setIndex((prev) => (prev + 1) % testimonials.length),
      5000
    ); // Slide every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const testimonial = testimonials[index];

  return (
    <section
      id="testimonials"
      className="py-24 px-6 bg-gradient-to-b from-[#10696a] to-[#0b3b52] text-center text-white"
    >
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-4xl font-extrabold mb-6"
      >
        What Our Clients Say
      </motion.h2>
      <p className="text-lg text-gray-200 mb-14 max-w-2xl mx-auto">
        Trusted by thousands of Canadians — our clients’ satisfaction is the
        reason behind our 95% approval rate and industry-leading service.
      </p>

      <motion.div
        key={index}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -40 }}
        transition={{ duration: 0.8 }}
        className="bg-white text-gray-800 rounded-3xl shadow-[0_0_30px_rgba(11,59,82,0.3)] max-w-3xl mx-auto p-10 relative"
      >
        <img
          src={testimonial.image}
          alt={testimonial.name}
          className="w-24 h-24 rounded-full object-cover border-4 border-teal-400 mx-auto mb-6 shadow-lg"
        />
        <div className="flex justify-center mb-4">
          {[...Array(testimonial.rating)].map((_, i) => (
            <FaStar key={i} className="text-yellow-400 text-xl mx-0.5" />
          ))}
        </div>
        <p className="text-gray-700 text-lg italic mb-4">
          “{testimonial.review}”
        </p>
        <h4 className="text-xl font-semibold text-[#0b3b52]">
          {testimonial.name}
        </h4>
        <p className="text-sm text-gray-500">{testimonial.location}</p>
      </motion.div>
    </section>
  );
}

export default Testimonials;
